<template>
  <div>
    <Loader cover v-if="classSectionProcessing || classSectionProcessing"/>

    <card-subject-info :classSectionId="$route.params.classSectionId" currentPage="WEB_BOARD"></card-subject-info>

    <vx-card>

      <web-board v-if="classSection" :classSection="classSection"></web-board>

    </vx-card>

  </div>
</template>

<script>
  import store from '../../../../store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import Loader from '../../../../components/common-ui/loader-block/index.vue';
  import ClassSection from '../../../../store/modules/courses/class-section/index';
  import CardSubjectInfo from "../../../../components/shared/card/CardSubjectInfo";
  import WebBoard from "./Components/WebBoard";

  if (!store.state.ClassSection) store.state.registerModule(`ClassSection`, ClassSection);

  const {
    mapActions: mapClassSectionActions,
  } = createNamespacedHelpers(`ClassSection`);

  const {
    mapFields: mapClassSectionFields,
  } = createHelpers({
    getterType: `ClassSection/getField`,
    mutationType: `ClassSection/updateField`,
  });

  export default {
    components: {
      Loader,
      CardSubjectInfo,
      WebBoard,
    },
    data() {
      return {
        classSection: null,
      }
    },
    computed: {
      ...mapClassSectionFields({
        classSectionProcessing: 'processing',
      }),
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapClassSectionActions({
        getClassSection: 'getClassSection',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onBackClick() {
        this.$router.push({
          name: 'home',
        })
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async initData() {
        const payload = {
          id: this.$route.params.classSectionId,
        };
        this.classSection = await this.getClassSection(payload);
      },
    },
    async beforeMount() {
      await this.initData();
    }
  }
</script>

<style scoped>

</style>

